import React, { useEffect, useState } from 'react';

const ConfirmModal = ({
  open,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  busy,
  input,
  inputType = 'text',
  inputLabel,
  inputPlaceholder,
  inputDefaultValue = ''
}) => {
  const [inputValue, setInputValue] = useState(inputDefaultValue);

  useEffect(() => {
    if (!open) return;
    setInputValue(inputDefaultValue);
  }, [open, inputDefaultValue]);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onCancel?.();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <div className="modal" style={{ width: 'min(520px, 100%)' }}>
        <div className="modal-header">
          <h3 className="text-lg font-semibold">{title}</h3>
          <button type="button" className="glass-button" onClick={onCancel} disabled={busy}>
            ✕
          </button>
        </div>
        <div className="modal-body">
          <div className="text-secondary">{message}</div>
          {input ? (
            <div className="mt-4">
              {inputLabel ? <label className="block text-sm font-medium mb-2">{inputLabel}</label> : null}
              {inputType === 'textarea' ? (
                <textarea
                  className="glass-textarea w-full"
                  rows={3}
                  placeholder={inputPlaceholder}
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  disabled={busy}
                />
              ) : (
                <input
                  className="glass-input w-full"
                  placeholder={inputPlaceholder}
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  disabled={busy}
                />
              )}
            </div>
          ) : null}
        </div>
        <div className="modal-footer">
          <button type="button" className="glass-button" onClick={onCancel} disabled={busy}>
            {cancelText}
          </button>
          <button type="button" className="glass-button danger" onClick={() => onConfirm?.(inputValue)} disabled={busy}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
